<template>
<div>
	<ul class="title-nav">
		<li v-on:click="handleBack()">
			<div class="back-btn">
				<i class="material-icons md-18">keyboard_arrow_left</i>
			</div> 
			
			<div class="title-label"><i class="material-icons md-18">cloud_download</i> DOWNLOADS (4)</div>
		</li>
	</ul>
	<div v-if="parcel.unlocked === false">
		<div class="lock-block" v-on:click="unlock">
			<div class="lock-icon-box">
				<i class="material-icons md-36">lock</i>
			</div>
			<div class="lock-text">
				<h5 class="mb-0 text-white">Unlock to download exports</h5>
				<h5 class="mb-0 font-weight-light text-light">${{plans.parcelUnlock.price}} to unlock this parcel</h5>
			</div>
		</div>
		<p class="font-sm">
			Unlock this parcel to download the formats listed below. Samples are provided to try before you buy.
		</p>
	</div>
	<div class="mb-3">
		<h5 class="mb-2">
			PROPERTY REPORT
			<small class="float-right text-muted font-weight-light mt-updated">updated {{parcel.updated | ago}}</small>
		</h5>
		<div class="field-row py-2 px-2 mb-1 clearfix">
			<label class="mb-0 font-weight-normal button-label">Client ready PDF</label>
			<div class="float-right font-weight-bold">
				<button v-if="parcel.unlocked === false" v-on:click="download('pdf')" class="btn btn-dark btn-sm"><i class="material-icons md-12">file_download</i> Sample</button>
				<button v-if="parcel.unlocked === true" v-on:click="download('pdf')" class="btn btn-dark btn-sm"><i class="material-icons md-12">file_download</i> Download</button>
			</div>
		</div>
	</div>
	<div class="mb-3">
		<h5 class="mb-2">
			PARCEL LOT LINES
			<small class="float-right text-muted font-weight-light mt-updated">updated {{parcel.updated | ago}}</small>
		</h5>
		<div class="field-row py-2 px-2 mb-1 clearfix">
			<label class="mb-0 font-weight-normal button-label">AutoCAD DXF</label>
			<div class="float-right font-weight-bold">
				<button v-if="parcel.unlocked === false" v-on:click="download('dxf')" class="btn btn-dark btn-sm"><i class="material-icons md-12">file_download</i> Sample</button>
				<button v-if="parcel.unlocked === true" v-on:click="download('dxf')" class="btn btn-dark btn-sm"><i class="material-icons md-12">file_download</i> Download</button>
			</div>
		</div>
		<div class="field-row py-2 px-2 mb-1 clearfix">
			<label class="mb-0 font-weight-normal button-label">Google Earth KML</label>
			<div class="float-right font-weight-bold">
				<button v-if="parcel.unlocked === false" v-on:click="download('kml')" class="btn btn-dark btn-sm"><i class="material-icons md-12">file_download</i> Sample</button>
				<button v-if="parcel.unlocked === true" v-on:click="download('kml')" class="btn btn-dark btn-sm"><i class="material-icons md-12">file_download</i> Download</button>
			</div>
		</div>
	</div>
	<div class="mb-3">
		<h5 class="mb-2">
			PARCEL DATA
			<small class="float-right text-muted font-weight-light mt-updated">updated {{parcel.updated | ago}}</small>
		</h5>
		<div class="field-row py-2 px-2 mb-1 clearfix">
			<label class="mb-0 font-weight-normal button-label">Excel CSV</label>
			<div class="float-right font-weight-bold">
				<button v-if="parcel.unlocked === false" v-on:click="download('csv')" class="btn btn-dark btn-sm"><i class="material-icons md-12">file_download</i> Sample</button>
				<button v-if="parcel.unlocked === true" v-on:click="download('csv')" class="btn btn-dark btn-sm"><i class="material-icons md-12">file_download</i> Download</button>
			</div>
		</div>
	</div>

</div>
</template>

<style>

.button-label{line-height:31px;}
.font-sm{font-size:0.8em;}
</style>

<script>

import moduleParcel from '../../store/modules/parcel' 

export default {
	props: {
		addressId: Number,
		handleBack: {
			type:Function,
			required:true
		},
		parcel:{
			type:Object,
			required:true,
		},
	},
	computed: {
		token:function(){
			return this.$store.state.agent.token;
		},
		plans:function(){
			return this.$store.state.plan.plans;
		}
	},
	methods:{
		unlock: function(){
			this.$router.push({
				name: 'unlock-parcel', 
				params:{
					parcelId: this.parcel.id
				},
				query:{
					addressId: this.addressId
				}
			});
		},
		download:function(type){
			let url;
			if (this.parcel.unlocked){
				url = moduleParcel.getters.getExportUrl({
					addressId: this.addressId,
					parcelId: this.parcel.id,
					format: type,
					token: this.token,
				})
			} else {
				switch(type) {
				case 'pdf':
					url = 'https://cdn.scoutred.com/web-static/download/examples/parcel-id-969509.pdf';
					break;
				case 'dxf':
					url = 'https://cdn.scoutred.com/web-static/download/examples/parcel-id-923640.dxf';
					break;
				case 'csv':
					url = 'https://s3.amazonaws.com/scoutred.com/web-static/download/examples/parcel-id-820969.csv';
					break;
				case 'kml':
					url = 'https://s3.amazonaws.com/scoutred.com/web-static/download/examples/parcel-id-820969.kml';
					break;
				default:
					this.$store.dispatch('SET_ERROR', 'unsupported file type: '+type);
				}
			}

			window.open(url);
		}
	}
}

</script>




// WEBPACK FOOTER //
// src/components/parcel/parcel-exports.vue